import { InvokeCallback, Sender } from "xstate";
import { withToken } from "@rentablo/api";
import { investmentsId } from "@rentablo/api/apiv1";
import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";
import { InvestmentValues } from "../types/investmentValues";

export const loadInvestment =
  (
    context: TransactionWizardContext,
    event: TransactionWizardEvent
  ): InvokeCallback<TransactionWizardEvent, TransactionWizardEvent> =>
  (callback) => {
    if (event.type !== "INIT_FROM_INVESTMENT")
      throw new Error(`Invalid event type ${event.type}`);

    load(event.id, callback);
  };

const load = async (id: number, callback: Sender<TransactionWizardEvent>) => {
  const getInvestment = withToken(investmentsId);
  try {
    const investment = await getInvestment({ id });

    const investmentValues: InvestmentValues = {
      id: investment.id,
      depotId: investment.account.id,
      name: investment.name,
      isin: investment.isin,
      wkn: investment.wkn,
      type: investment.type,
      tickerSymbol: investment.tickerSymbol,
      quoteProvider: investment.quote?.quoteProvider,
      quoteCurrency: investment.quote?.currency,
      investmentCurrency: investment.currency,
      numberOfLots: investment.numberOfLots,
    };

    callback({
      type: "INVESTMENT_INITIALIZED",
      investmentValues: investmentValues,
      accountCurrency: investment.account.currency,
      entryQuote: investment.quote?.last,
    });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
